export default __webpack_public_path__ + "static/img_spindlebooks_solutions-74743481ca7d74ff743db8934a5e33e8.png";